import { render, staticRenderFns } from "./AsACoachCheckpointShowAllCard.vue?vue&type=template&id=6ab2a16c&scoped=true"
import script from "./AsACoachCheckpointShowAllCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachCheckpointShowAllCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachCheckpointShowAllCard.vue?vue&type=style&index=0&id=6ab2a16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab2a16c",
  null
  
)

export default component.exports